import React from "react";
import { Field, useFormikContext } from "formik";
import AutoCompleteFibre from "./AutoCompleteFibre";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { StyledTextField } from "./CommonStyles";

const GarmentFibreComponent = ({
  name,
  fibreIndex,
  garmentIndex,
  garment,
  fibre,
  options,
  showAlias,
  isFieldHidden,
  onAutoCompleteChange,
  maxComponents,
  setOpen,
  globalTotalParts
}) => {
  const { setFieldValue } = useFormikContext();

  const addFibre = (garmentIndex, fibreIndex, fibres) => {
    if (globalTotalParts >= maxComponents) {
      setOpen({
        operBar: true,
        message: `You cannot enter more than ${maxComponents} components`,
        isValidPercentage: false,
      });
      return; // prevent exceeding limit
    }
    fibres.splice(fibreIndex + 1, 0, { fibre: "", percentage: 0 });
    //setFieldValue(`${name}[${garmentIndex}].fibres`, fibres);
  };

  const removeFibre = (garmentIndex, fibreIndex, fibres) => {
    fibres.splice(fibreIndex, 1);
    //setFieldValue(`${name}[${garmentIndex}].fibres`, fibres);
  };
  return (
    <div className="fiber-flex-container">
      <div className="flex-fibre-item-right"></div>
      <div className="flex-fibre-item-right">
        {!isFieldHidden && (
          <>
            <Field
              type="number"
              as={StyledTextField}
              size="small"
              sx={{ width: 150 }}
              name={`${name}[${garmentIndex}].fibres[${fibreIndex}].percentage`}
              disabled={garment?.isSave}
              // onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
            />

            <label>%</label>
          </>
        )}
        <AutoCompleteFibre
          options={options}
          name={`${name}[${garmentIndex}].fibres[${fibreIndex}].fibre`}
          setFieldValue={setFieldValue}
          garmentFibre={fibre}
          disabled={garment?.isSave}
          errorBorder={garment?.errorBorder}
          showAlias={showAlias}
          onChange={(shouldHide) => onAutoCompleteChange(shouldHide)}
        />

        {garment?.fibres?.length === fibreIndex + 1 ? (
          <IconButton
            data-testid="add-button"
            disabled={garment?.isSave}
            onClick={() => addFibre(garmentIndex, fibreIndex, garment?.fibres)}
          >
            <AddIcon fontSize="small" color="primary" />
          </IconButton>
        ) : null}
        {garment?.fibres?.length !== 1 ? (
          <IconButton
            data-testid="remove-button"
            disabled={garment?.isSave}
            onClick={() =>
              removeFibre(garmentIndex, fibreIndex, garment?.fibres)
            }
          >
            <RemoveIcon color="primary" fontSize="small" />
          </IconButton>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(GarmentFibreComponent);
